<template>
	<div v-if="card.length>0" class="row">
		<div
			v-for="data in card"
			:key="data.course"
			:class="
				`col-md-6 col-xl-` +
				(card.length % 4 === 0
					? '3'
					: card.length % 3 === 0
					? '4'
					: card.length === 2
					? '6'
					: '4')
			"
		>
			<a
				class="block block-rounded block-link-shadow"
				href="javascript:void(0)"
			>
				<div class="block-content block-content-full text-end">
					<div class="fs-2 fw-bold">{{ data.total }}</div>
					<div class="text-muted">TOTAL ENTRIES</div>
					<div class="fs-sm fw-semibold text-uppercase text-muted">
						{{ data.course }}
					</div>
				</div>
				<div class="block-content block-content-full d-flex justify-content-between align-items-center text-center">
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ data.new }}</h6>
						<span>New</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ data.upgrade }}</h6>
						<span>Upgrade</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ data.renew }}</h6>
						<span>Renewal</span>
					</div>
				</div>
			</a>
		</div>
	</div>
	<div v-if="card.length<=0" class="row">
		<div class="col-lg-12">
			<div class="block block-rounded block-link-shadow">
				<div class="block-content">
					<p class="p-5 text-bold text-danger text-center">No Record Found</p>	
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		card: Object,
	},
}
</script>
